import { emailRegex } from '@components/utils';
import Container from '@components/components/Container/Container';
import styles from '@components/components/OrderFormTanke/OrderFormTanke.module.scss';
import { useAjax, useTracking } from '@components/hooks';
import {
  useFormStore,
  FormSubmit,
  FormLabel,
  FormRadio,
  FormRadioGroup,
  Form,
  FormGroupLabel,
} from '@ariakit/react';
import {
  Button,
  Card,
  CardBody,
  Content,
  FontAwesomeProIcon,
  InputField,
  Link,
  List,
  ListItem,
  Radio,
  Select,
  Textarea,
} from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import React, { useState, useRef } from 'react';

const DataStepLadeBox = ({ product, productType, store }) => {
  const values = store.useState();
  const textareaRef = useRef(null);

  const handleChange = () => {
    textareaRef.current.style.height = '53px';
    textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
  };

  return (
    <Card>
      <CardBody>
        {values.customer === 'business' && (
          <InputField
            className={styles.field}
            label="Gemeinde, bzw. Unternehmen (optional)"
            name="company"
            store={store}
          />
        )}
        <FormRadioGroup
          aria-label="anrede"
          className={styles.radioGroup}
          name="anrede"
          store={store}
        >
          <FormLabel
            className={styles.radioLabel}
            name="anrede"
            render={<legend />}
            store={store}
          >
            Anrede
          </FormLabel>
          <div className={styles.radios}>
            <FormRadio
              name="anrede"
              render={
                <Radio align="center" label="Frau" variant="horizontal" />
              }
              store={store}
              value="frau"
            />
            <FormRadio
              name="anrede"
              render={
                <Radio align="center" label="Herr" variant="horizontal" />
              }
              store={store}
              value="herr"
            />
            <FormRadio
              name="anrede"
              render={
                <Radio align="center" label="Divers" variant="vertical" />
              }
              required
              store={store}
              value="divers"
            />
          </div>
        </FormRadioGroup>
        <InputField
          className={styles.field}
          label="Vorname"
          name="vorname"
          required
          store={store}
        />
        <InputField
          className={styles.field}
          label="Nachname"
          name="nachname"
          required
          store={store}
        />

        <InputField
          className={styles.field}
          label="Telefon (optional)"
          name="telefonnummer"
          store={store}
        />
        <InputField
          className={styles.field}
          label="E-Mail-Adresse"
          name="email"
          required
          store={store}
        />
        <InputField
          className={styles.field}
          label="Straße"
          name="strasse"
          required
          store={store}
        />

        <div className={styles.flexCol}>
          <InputField
            className={classNames(styles.field, styles.flexItem, styles.equal)}
            label="Hausnummer"
            name="hausnummer"
            required
            store={store}
          />

          <InputField
            className={classNames(styles.field, styles.flexItem, styles.equal)}
            label="Stiege (optional)"
            name="stiege"
            store={store}
          />

          <InputField
            className={classNames(styles.field, styles.flexItem, styles.equal)}
            label="Tür (optional)"
            name="tuer"
            store={store}
          />
        </div>

        <div className={styles.flexCol}>
          <InputField
            className={classNames(styles.field, styles.flexItem, styles.third)}
            label="PLZ"
            name="plz"
            required
            store={store}
          />

          <InputField
            className={classNames(
              styles.field,
              styles.flexItem,
              styles.twoThird,
            )}
            label="Ort"
            name="ort"
            required
            store={store}
          />
        </div>
        {product === 'wohnbau' && productType === 'ladeboxen' && (
          <InputField
            className={styles.field}
            label="Stellplatznummer (optional)"
            name="stellplatznummer"
            onChange={handleChange}
            store={store}
          />
        )}
        <Textarea
          className={styles.field}
          label="Möchten Sie uns noch etwas mitteilen? (optional)"
          name="message"
          onChange={handleChange}
          ref={textareaRef}
          store={store}
        />
        <br />
        <Content size="sm">
          Nähere Informationen zu Art, Umfang und Zweck der Verarbeitung Ihrer
          personenbezogenen Daten sowie zu den Rechten auf Auskunft,
          Berichtigung, Löschung, Einschränkung der Verarbeitung, Widerruf und
          Übertragbarkeit finden sich auf{' '}
          <Link to="https://www.wienenergie.at/datenschutz">
            www.wienenergie.at/datenschutz
          </Link>
          . Weiters besteht die Möglichkeit einer Kontaktaufnahme unter{' '}
          <Link to="mailto:datenschutz@wienenergie.at">
            datenschutz@wienenergie.at
          </Link>{' '}
          an den Datenschutzbeauftragten sowie an die Österreichische
          Datenschutzbehörde.
        </Content>
        <div className={styles.actions}>
          <FormSubmit
            render={
              <Button className={styles.action} id="senden">
                Senden
              </Button>
            }
            store={store}
          />
        </div>
      </CardBody>
    </Card>
  );
};

const DataStepLadeKarten = ({ store }) => {
  const values = store.useState();

  return (
    <Card>
      <CardBody>
        <FormRadioGroup
          aria-label="customer type"
          className={styles.radioGroup}
          name="customer"
          store={store}
        >
          {/* change to FormGroupLabel */}
          <FormGroupLabel
            className={styles.radioLabel}
            name="customer"
            store={store}
          >
            Ich bestelle als …
          </FormGroupLabel>
          <div className={styles.radios}>
            <FormRadio
              name="customer"
              render={
                <Radio
                  align="center"
                  label="Privatkunde"
                  variant="horizontal"
                />
              }
              store={store}
              value="privat"
            />
            <FormRadio
              name="customer"
              render={
                <Radio
                  align="center"
                  label="Businesskunde"
                  variant="horizontal"
                />
              }
              store={store}
              value="business"
            />
          </div>
        </FormRadioGroup>
        {values.customer === 'business' && (
          <InputField
            className={styles.field}
            label="Firmenbezeichnung (optional)"
            name="company"
            store={store}
          />
        )}
        <FormRadioGroup
          aria-label="anrede"
          className={styles.radioGroup}
          name="anrede"
          store={store}
        >
          <FormGroupLabel
            className={styles.radioLabel}
            name="anrede"
            store={store}
          >
            Anrede
          </FormGroupLabel>
          <div className={styles.radios}>
            <FormRadio
              name="anrede"
              render={
                <Radio align="center" label="Frau" variant="horizontal" />
              }
              store={store}
              value="frau"
            />
            <FormRadio
              align="center"
              label="Herr"
              name="anrede"
              render={
                <Radio align="center" label="Herr" variant="horizontal" />
              }
              store={store}
              value="herr"
              variant="horizontal"
            />
          </div>
        </FormRadioGroup>
        <InputField
          className={styles.field}
          label="Vorname"
          name="vorname"
          required
          store={store}
        />
        <InputField
          className={styles.field}
          label="Nachname"
          name="nachname"
          required
          store={store}
        />
        <InputField
          className={styles.field}
          label="Telefon (optional)"
          name="telefonnummer"
          store={store}
        />
        <InputField
          className={styles.field}
          label="E-Mail-Adresse"
          name="email"
          required
          store={store}
        />
        <InputField
          className={styles.field}
          label="Straße"
          name="strasse"
          required
          store={store}
        />

        <div className={styles.flexCol}>
          <InputField
            className={classNames(styles.field, styles.flexItem, styles.equal)}
            label="Hausnummer"
            name="hausnummer"
            required
            store={store}
          />

          <InputField
            className={classNames(styles.field, styles.flexItem, styles.equal)}
            label="Stiege (optional)"
            name="stiege"
            store={store}
          />

          <InputField
            className={classNames(styles.field, styles.flexItem, styles.equal)}
            label="Tür (optional)"
            name="tuer"
            store={store}
          />
        </div>

        <div className={styles.flexCol}>
          <InputField
            className={classNames(styles.field, styles.flexItem, styles.third)}
            label="PLZ"
            name="plz"
            required
            store={store}
          />

          <InputField
            className={classNames(
              styles.field,
              styles.flexItem,
              styles.twoThird,
            )}
            label="Ort"
            name="ort"
            required
            store={store}
          />
        </div>
        <Select
          className={classNames(styles.field, styles.flexItem, styles.equal)}
          items={[
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
          ]}
          label="Wie viele Ladekarten möchten Sie bestellen?"
          name="ladekarten"
          placeholder="Bitte auswählen"
          store={store}
        />
        <br />
        <Content size="sm">
          Nähere Informationen zu Art, Umfang und Zweck der Datenverarbeitungen
          sowie zu den Rechten auf Auskunft, Berichtigung, Löschung,
          Einschränkung der Verarbeitung, Widerruf und Übertragbarkeit finden
          sich auf{' '}
          <Link to="https://www.wienenergie.at/datenschutz">
            www.wienenergie.at/datenschutz
          </Link>
          . Weiters besteht die Möglichkeit einer Kontaktaufnahme unter{' '}
          <Link to="mailto:datenschutz@wienenergie.at">
            datenschutz@wienenergie.at
          </Link>{' '}
          an den Datenschutzbeauftragten sowie an die Österreichische
          Datenschutzbehörde.
        </Content>
        <div className={styles.actions}>
          <FormSubmit
            render={
              <Button className={styles.action} id="anfordern">
                LADEKARTE(N) ANFORDERN
              </Button>
            }
            store={store}
          />
        </div>
      </CardBody>
    </Card>
  );
};

const Failed = ({ store, prev, failed, referrer }) => {
  const values = store.useState();

  return (
    <Card>
      <CardBody>
        <List
          align="center"
          className={styles.list}
          icon={
            <FontAwesomeProIcon
              icon="times"
              role="presentation"
              type="regular"
            />
          }
          type="checkmark"
          variant="error"
        >
          <ListItem data-purpose="error-message">
            Es ist ein Fehler aufgetreten.
          </ListItem>
        </List>
        <Content as="div" withParser>
          {failed}
        </Content>
        <Content>
          Bei Fragen sind wir gern per E-Mail unter{' '}
          <a
            href={`mailto:${values.supportEmail}`}
            rel="noreferrer"
            target="_blank"
          >
            {values.supportEmail}
          </a>{' '}
          für Sie da!
        </Content>
        <div className={styles.actions}>
          {!!referrer && (
            <Button
              render={
                <Link className={styles.action} to={referrer.url}>
                  {referrer.title || 'Zurück zur Übersicht'}
                </Link>
              }
              variant="link"
            />
          )}

          <Button className={styles.action} onClick={prev} variant="link">
            Nochmal versuchen
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

const Success = ({ referrer, success }) => (
  <Card>
    <CardBody>
      <List
        align="center"
        className={styles.list}
        icon={
          <FontAwesomeProIcon icon="check" role="presentation" type="regular" />
        }
        type="checkmark"
      >
        <ListItem data-purpose="success-message">
          Danke für Ihre Anfrage!
        </ListItem>
      </List>
      <Content as="div" withParser>
        {success}
      </Content>
      {!!referrer && (
        <Button
          render={
            <Link className={styles.action} to={referrer?.url}>
              {referrer?.title}
            </Link>
          }
          variant="link"
        />
      )}
    </CardBody>
  </Card>
);

const steps = [
  {
    component: DataStepLadeBox,
    name: 'ladebox',
    order: 1,
    realSubmit: true,
    required: {
      vorname: 'Vorname',
      nachname: 'Nachname',
      email: 'E-mail',
      strasse: 'Straße',
      hausnummer: 'Hausnummer',
      plz: 'PLZ',
      ort: 'Ort',
    },
    validation: store => {
      const email = store.getValue('email');

      if (!emailRegex.test(email.trim().toLowerCase())) {
        store.setError('email', 'E-Mail-Adresse muss gültig sein');
      }
    },
  },
  {
    component: DataStepLadeKarten,
    name: 'ladekarten',
    order: 2,
    realSubmit: true,
    required: {
      customer: 'Kundentyp',
      vorname: 'Vorname',
      nachname: 'Nachname',
      email: 'E-mail',
      strasse: 'Straße',
      hausnummer: 'Hausnummer',
      plz: 'PLZ',
      ort: 'Ort',
      ladekarten: 'Ladekarten Anzahl',
    },
    validation: store => {
      const email = store.getValue('email');

      if (!emailRegex.test(email.trim().toLowerCase())) {
        store.setError('email', 'E-Mail-Adresse muss gültig sein');
      }
    },
  },
  {
    component: Success,
    name: 'success',
    order: 3,
  },
  {
    component: Failed,
    name: 'failed',
    order: 4,
  },
];

const OrderFormTanke = ({
  product,
  email: supportEmail,
  customer,
  referrer,
  productType,
  success,
  failed,
  blockId,
}) => {
  const initialStep = productType === 'ladeboxen' ? 1 : 2;
  const [step, setStep] = useState(initialStep);
  const formRef = useRef(null);
  const track = useTracking();
  const [sendOrder] = useAjax('we_theme_order_tanke');

  const ladekartenField =
    productType === 'ladekarten' ? { ladekarten: '' } : null;

  const [values, setValues] = useState({
    product,
    referrer,
    initialStep,
    ...ladekartenField,
    customer,
    supportEmail,
    company: '',
    anrede: 'frau',
    vorname: '',
    nachname: '',
    telefonnummer: '',
    email: '',
    strasse: '',
    hausnummer: '',
    stiege: '',
    tuer: '',
    plz: '',
    ort: '',
    message: '',
  });
  const form = useFormStore({ values, setValues });

  form.useValidate(() => {
    const currentStep = steps.find(item => item.order === step);

    if (currentStep.required) {
      Object.keys(currentStep.required).forEach(key => {
        if (!values[key]) {
          form.setError(key, `${currentStep.required[key]} ist erforderlich`);
        }
      });
    }

    if (currentStep.validation) {
      currentStep.validation(form);
    }
  });

  form.useSubmit(async () => {
    if (steps.find(item => item.order === step).realSubmit) {
      try {
        const postValues = {
          ...values,
          product,
          blockId,
          ladekarten: values.ladekarten?.value,
        };
        const { data: response } = await sendOrder(postValues);

        if (!response.success) {
          throw new Error(response.data[0].message);
        }

        track({
          event: 'productordertanke_abgeschlossen',
          options: product,
          customer: postValues.customer,
          PLZ: postValues.plz,
        });
        form.reset();
        setStep(3);
      } catch (error) {
        setStep(4);
      } finally {
        window.scrollTo({
          top:
            window.scrollY + formRef.current.getBoundingClientRect().top - 200,
          behavior: 'smooth',
        });
      }
    }
  });

  const renderStep = () => {
    const currentStepComponent = steps.filter(item => item.order === step)[0];
    return (
      <currentStepComponent.component
        failed={failed}
        prev={() => {
          setStep(values.initialStep);
        }}
        product={product}
        productType={productType}
        referrer={referrer}
        setStep={setStep}
        store={form}
        success={success}
      />
    );
  };

  return (
    <Container size="lg">
      <Form
        className={styles.form}
        data-purpose="order-tanke-form"
        ref={formRef}
        store={form}
      >
        {renderStep()}
      </Form>
    </Container>
  );
};

export default OrderFormTanke;
